<template>
  <div class="appBlock">
    <div class="steps" v-show="!prew_history">
      <a-drawer :title="$t('Comment')" placement="bottom" :height="heightWindow" @close="onClose"
        :visible="isCommentVisible">
        <template>
          <a-list v-if="comments.length != 0" :dataSource="comments" :header="`${comments.length} ${comments.length > 1 ? $t('records') : $t('record')
            }`" itemLayout="horizontal">
            <a-list-item slot="renderItem" slot-scope="item">
              <a-comment :author="item.FIO" :content="item.content" :datetime="item.datetime">
                <a-avatar slot="avatar" :src="item.photo == ''
                    ? 'https://voxpopulii.in/system/static/dashboard/img/default_user.png'
                    : item.photo
                  " :alt="profile.NAME + ' ' + profile.LAST_NAME" />
              </a-comment>
            </a-list-item>
          </a-list>

          <a-comment>
            <a-avatar slot="avatar" :src="profile.PERSONAL_PHOTO == null
                ? 'https://voxpopulii.in/system/static/dashboard/img/default_user.png'
                : profile.PERSONAL_PHOTO
              " :alt="profile.NAME + ' ' + profile.LAST_NAME" />
            <div slot="content">
              <a-form-item>
                <a-textarea :rows="2" @change="handleChangeComment" :value="valueComment"></a-textarea>
              </a-form-item>
              <a-form-item style="padding-bottom: 20px">
                <a-button htmlType="submit" :disabled="submittingComment" :loading="submittingComment"
                  @click="handleSubmitComment" type="primary">{{ $t("Add Comment") }}</a-button>
              </a-form-item>
            </div>
          </a-comment>
        </template>
      </a-drawer>
      <a-steps :current="current" size="small">
        <a-step v-for="(item, index) in steps" :key="item.title" :title="index < current
            ? $t('Completed')
            : index == current
              ? $t('Running')
              : $t('Awaiting')
          " :description="item.content" />
      </a-steps>
    </div>
    <a-row v-show="!prew_history" style="padding: 10px 0px" align="middle">
      <a-col :span="10" style="display: flex">
        <a-button-group>
          <a-button @click="handleHistoryFile">
            <a-icon type="history" />
            {{ $t("Change log") }}
          </a-button>
          <a-button icon="eye" @click="preview">{{ $t("Preview") }}</a-button>
          <a-button @click="myPrint" type="primary" icon="printer">{{
            $t("Print")
            }}</a-button>
          <a-button type="primary" :href="element.url" icon="download">
            {{ $t("Download") }}
          </a-button>
        </a-button-group>
        <div style="margin-left: 15px">
          <a-upload :fileList="fileList" :beforeUpload="beforeUpload" :multiple="true">
            <a-button :disabled="!currentEdit" icon="file-add" type="primary" :loading="uploading" />
          </a-upload>
        </div>
        <a-button v-if="newPages.includes(currentPage)" :loading="DeletePageloading" @click="showDeleteConfirm"
          type="danger" icon="delete" />
      </a-col>
      <a-col :span="6" style="text-align: center">
        <div v-if="currentEdit" style="display: flex; align-items: center; justify-content: center">
          <a-statistic-countdown :value="deadline" @finish="onFinish" format="mm:ss" style="margin-right: 10px" />
          <a-tooltip :title="$t('Time until the end of the session')">
            <a-icon type="info-circle" />
          </a-tooltip>
        </div>
        <span v-else>{{
          $t("This file is edited by") + " " + getUser(element.currentlyeditor)
          }}</span>
      </a-col>
      <a-col :span="8" style="text-align: right">
        <a-button-group style="margin-right: 25px">
          <a-button v-if="element.status != 'NOWY' && profile.ADMIN" @click="
            (e) => {
              if (element.status == 'DO OPISANIA') {
                handleReturnToNew();
              } else {
                handleReturnToDesc();
              }
            }
          " :disabled="disableFromResponsible || !currentEdit" type="primary">
            <a-icon type="left" />
            {{ $t("Back") }}
          </a-button>
          <a-button v-if="element.status != 'ZARCHIWIZOWANY'" @click="submit"
            :disabled="disableFromResponsible || !currentEdit" type="primary">
            {{ $t("Save") }}
            <a-icon type="right" />
          </a-button>
        </a-button-group>
        <a-button type="danger" icon="close" @click="back" />
      </a-col>
    </a-row>
    <a-spin :spinning="spinning" size="large">
      <div style="border: 1px solid lightgray; border-radius: 5px">
        <div class="mainBlock--form">
          <div class="Form" v-show="!prew_history">

            <a-spin :spinning="prew_doc_spinner" style="width: 60%">
              <template v-if="!prew_doc">
                <div v-if="docPdf" style="position: relative; margin: 15px">
                  <div style="
                      display: flex;
                      justify-content: space-between;
                      margin-bottom: 10px;
                    ">
                    <a-button :disabled="currentPage - 1 < 1 ? true : false" @click="
                      () => {
                        currentPage--;
                        getpdf();
                      }
                    ">
                      <a-icon type="left" />
                      {{ $t("Prev") }}
                    </a-button>
                    <span>{{ currentPage }} / {{ countPages }}</span>
                    <a-button :disabled="currentPage + 1 > countPages ? true : false" @click="
                      () => {
                        currentPage++;
                        getpdf();
                      }
                    ">
                      {{ $t("Next") }}
                      <a-icon type="right" />
                    </a-button>
                  </div>
                  <canvas id="pdf-canvas-step" class="pdf-canvas"></canvas>
                  <div id="text-layer-step" class="text-layer"></div>
                  <div style="display: flex; justify-content: space-between">
                    <a-button :disabled="currentPage - 1 < 1 ? true : false" @click="
                      () => {
                        currentPage--;
                        getpdf();
                      }
                    ">
                      <a-icon type="left" />
                      {{ $t("Prev") }}
                    </a-button>
                    <span>{{ currentPage }} / {{ countPages }}</span>
                    <a-button :disabled="currentPage + 1 > countPages ? true : false" @click="
                      () => {
                        currentPage++;
                        getpdf();
                      }
                    ">
                      {{ $t("Next") }}
                      <a-icon type="right" />
                    </a-button>
                  </div>
                </div>

                <div  v-else style="width: 100%">
                  <img :src="`${element.DOWNLOAD_URL != undefined
                      ? element.DOWNLOAD_URL
                      : element.url
                    }`" style="width: 100%"  />
                  <div>test</div>
                </div>

              </template>

              <div v-else>
                <a-empty />
              </div>

            </a-spin>

            <div style="width: 40%">
              <firstStep v-if="current == 0" v-on:show-comments="isCommentVisible = !isCommentVisible"
                :commentsData="comments" :disableFromResponsible="disableFromResponsible" :document="element"
                :profile="profile" :currentEdit="currentEdit" :bounds="bounds" :info="form_info"
                :user_setup="user_setup" :USER_LIST="USER_LIST" :COMPANY_LIST="COMPANY_LIST"
                :MY_COMPANY_LIST="MY_COMPANY_LIST" ref="form" @onback="back" @changeSpinning="changeSpinning" />
              <secondStep v-else-if="current == 1" :document="element" :USER_LIST="USER_LIST" :commentsData="comments"
                :COMPANY_LIST="COMPANY_LIST" :MY_COMPANY_LIST="MY_COMPANY_LIST"
                :disableFromResponsible="disableFromResponsible"
                v-on:show-comments="isCommentVisible = !isCommentVisible" :info="form_info" :responsible="responsible"
                :currentEdit="currentEdit" :bounds="bounds" :key_words="key_words" :profile="profile"
                :specialization="specialization" ref="form" @onback="back" @changeSpinning="changeSpinning" />
              <thirdStep v-else :document="element" :commentsData="comments" :COMPANY_LIST="COMPANY_LIST"
                :MY_COMPANY_LIST="MY_COMPANY_LIST" v-on:show-comments="isCommentVisible = !isCommentVisible"
                :info="form_info" :currentEdit="currentEdit" :key_words="key_words" :specialization="specialization"
                :responsible="responsible" :profile="profile" ref="form" @onback="back"
                @changeSpinning="changeSpinning" />
              <template>
                <a-list id="my_comments_styl" v-if="comments.length != 0" :dataSource="comments" :header="`${comments.length} ${comments.length > 1 ? $t('records') : $t('record')
                  }`" itemLayout="horizontal">
                  <a-list-item slot="renderItem" slot-scope="item">
                    <a-comment :author="item.FIO" :content="item.content" :datetime="item.datetime">
                      <a-avatar slot="avatar" :src="item.photo == ''
                          ? 'https://voxpopulii.in/system/static/dashboard/img/default_user.png'
                          : item.photo
                        " :alt="profile.NAME + ' ' + profile.LAST_NAME" />
                    </a-comment>
                  </a-list-item>
                </a-list>

                <a-comment style="padding: 0 15px">
                  <a-avatar slot="avatar" :src="profile.PERSONAL_PHOTO == null
                      ? 'https://voxpopulii.in/system/static/dashboard/img/default_user.png'
                      : profile.PERSONAL_PHOTO
                    " :alt="profile.NAME + ' ' + profile.LAST_NAME" />
                  <div slot="content">
                    <a-form-item>
                      <a-textarea :rows="2" @change="handleChangeComment" :value="valueComment"></a-textarea>
                    </a-form-item>
                    <a-form-item style="padding-bottom: 20px">
                      <a-button htmlType="submit" :disabled="submittingComment" :loading="submittingComment"
                        @click="handleSubmitComment" type="primary">{{ $t("Add Comment") }}</a-button>
                    </a-form-item>
                  </div>
                </a-comment>
              </template>
            </div>
          </div>
          <documentHistory v-if="prew_history" :document="element" :info="form_info" style="padding: 15px"
            @onBack="prew_history = false" />
        </div>
      </div>
    </a-spin>
    <div class="mainBlock--btn">
      <a-row v-show="!prew_history" style="padding: 10px 0px" align="middle">
        <a-col :span="10" style="display: flex">
          <a-button-group>
            <a-button @click="handleHistoryFile">
              <a-icon type="history" />
              {{ $t("Change log") }}
            </a-button>
            <a-button icon="eye" @click="preview">{{ $t("Preview") }}</a-button>
            <a-button @click="myPrint" type="primary" icon="printer">{{
              $t("Print")
              }}</a-button>
            <a-button type="primary" :href="element.url" icon="download">
              {{ $t("Download") }}
            </a-button>
          </a-button-group>
          <div style="margin-left: 15px">
            <a-upload :fileList="fileList" :beforeUpload="beforeUpload" :multiple="true">
              <a-button :disabled="!currentEdit" icon="file-add" type="primary" :loading="uploading" />
            </a-upload>
          </div>
          <a-button v-if="newPages.includes(currentPage)" :loading="DeletePageloading" @click="showDeleteConfirm"
            type="danger" icon="delete" />
        </a-col>
        <a-col :span="4" style="text-align: center">
          <div v-if="currentEdit" style="display: flex; align-items: center; justify-content: center">
            <a-statistic-countdown :value="deadline" @finish="onFinish" format="mm:ss" style="margin-right: 10px" />
            <a-tooltip :title="$t('Time until the end of the session')">
              <a-icon type="info-circle" />
            </a-tooltip>
          </div>
          <span v-else>{{
            $t("This file is edited by") +
            " " +
            getUser(element.currentlyeditor)
            }}</span>
        </a-col>
        <a-col :span="10" style="text-align: right;display: flex;justify-content: flex-end;">
          <div style="margin-right: 20px;width: 292px;font-size:11px">{{ $t('After all the data is filled out correctly, the document will move to the next stage automatically.') }}</div>
          <a-button-group>
            <a-button v-if="element.status != 'NOWY' && profile.ADMIN" @click="
              (e) => {
                if (element.status == 'DO OPISANIA') {
                  handleReturnToNew();
                } else {
                  handleReturnToDesc();
                }
              }
            " :disabled="disableFromResponsible || !currentEdit" type="primary">
              <a-icon type="left" />
              {{ $t("Back") }}
            </a-button>
            <a-button v-if="element.status != 'ZARCHIWIZOWANY'" @click="submit"
              :disabled="disableFromResponsible || !currentEdit" type="primary">
              {{ $t("Save") }}
              <a-icon type="right" />
            </a-button>
            <!--</a-button-group>
<a-tooltip style="margin-right: 15px" :title="$t('After all the data is filled out correctly, the document will move to the next stage automatically.')">
              <a-icon type="info-circle" />
          </a-tooltip>-->
            <a-button style="margin-left:15px" type="danger" icon="close" @click="back" />
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import firstStep from "./steps/first";
import secondStep from "./steps/second";
import thirdStep from "./steps/third";
import documentHistory from "./documentHistory.vue";
import {
  getHistory,
  uploadFile,
  deletePage,
  commentAdd,
  editClose,
  returnToDescription,
  returnToNew,
  // findOCR,
} from "@/requestFunc";
var pdfjsLib = require("pdfjs-dist/build/pdf");
var pdfjsWorker = require("pdfjs-dist/build/pdf.worker.entry");
import printJS from "print-js";
import moment from "moment";
export default {
  props: [
    "element",
    "navigation",
    "profile",
    "current",
    "form_info",
    "key_words",
    "specialization",
    "disableFromResponsible",
    "responsible",
    "user_setup",
    "COMPANY_LIST",
    "MY_COMPANY_LIST",
    "USER_LIST",
  ],
  components: {
    firstStep,
    secondStep,
    thirdStep,
    documentHistory,
  },
  data() {
    return {
      currentPage: 1,
      countPages: 1,
      deadline: 0,
      currentEdit: false,
      submittingComment: false,
      isCommentVisible: false,
      DeletePageloading: false,
      bounds: [],
      valueComment: "",
      newPages: [],
      spinning: false,
      addFileList: [],
      uploading: false,
      prew_doc_spinner: true,
      docPdf: true,
      flagRename: false,
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
      prew_history: false,
      prew_doc: false,
      steps: [
        {
          content: this.$t("Pre-register document"),
        },
        {
          content: this.$t("Document Description"),
        },
        {
          content: this.$t("Archiving document"),
        },
      ],
    };
  },
  computed: {
    comments() {
      if (this.element.allcomments != undefined) {
        for (let item of this.element.allcomments) {
          let user = this.element.userList.find((x) => x.ID == item.author);
          item["FIO"] = user.NAME + " " + user.LAST_NAME;
          item["photo"] =
            user.PERSONAL_PHOTO != null ? user.PERSONAL_PHOTO : "";
          item.like = JSON.parse(item.like);
          item.dislike = JSON.parse(item.dislike);
          item["likes"] = item.like.length;
          item["dislikes"] = item.dislike.length;
        }
        return this.element.allcomments;
      }
      return [];
    },
  },
  methods: {
    moment,
    onClose() {
      this.isCommentVisible = false;
    },
    heightWindow() {
      return parseInt($("#app").css("height") + 5);
    },
    onFinish() {
      this.back({});
    },
    handleSubmitComment() {
      if (!this.valueComment) {
        return;
      }
      this.submittingComment = true;
      var comment = {
        FIO: this.profile.NAME + " " + this.profile.LAST_NAME,
        author: this.profile.ID,
        photo:
          this.profile.PERSONAL_PHOTO != null
            ? this.profile.PERSONAL_PHOTO
            : "",
        content: this.valueComment,
        likes: 0,
        like: ["23"],
        dislikes: 0,
        dislike: ["33"],
        datetime: moment().format("YYYY-MM-DD hh:mm:ss"),
      };
      this.comments.push(comment);
      this.valueComment = "";
      commentAdd([comment], this.element)
        .done(() => {
          /* if (this.element.mainid == undefined) {
            let elem = JSON.parse(x);
            this.element = elem;
          }*/
          this.$message.success("upload comment successfully.");
        })
        .fail((e) => {
          console.error(e);
          this.$message.error("upload comment failed.");
        })
        .always(() => {
          this.submittingComment = false;
          BX24.fitWindow();
        });
    },
    handleChangeComment(e) {
      this.valueComment = e.target.value;
    },
    dislike() {
      this.likes = 0;
      this.dislikes = 1;
      this.action = "disliked";
    },
    myPrint() {
      printJS({
        printable:
          this.element.DOWNLOAD_URL == undefined
            ? this.element.url
            : this.element.DOWNLOAD_URL,
        type: "pdf",
        showModal: true,
      });
    },
    beforeUpload(file) {
      this.addFileList = [...this.addFileList, file];
      this.handleUploadFile();
      return false;
    },
    handleUploadFile() {
      var formData = new FormData();
      formData.append("run", "filemerge");
      formData.append("ID", this.element.ID);
      formData.append("download_url", this.element.DOWNLOAD_URL);
      this.addFileList.forEach((file) => {
        formData.append("files[]", file);
      });

      this.uploading = true;
      uploadFile(formData)
        .done((x) => {
          var res = JSON.parse(x);
          for (
            let i = this.countPages + 1;
            i <= this.countPages + res.count_page;
            i++
          ) {
            this.newPages.push(i);
          }
          this.addFileList = [];
          this.uploading = false;
          this.currentPage = this.countPages + 1;
          this.getpdf();
          this.$message.success("upload successfully.");
        })
        .fail((e) => {
          this.uploading = false;
          console.err(e);
          this.$message.error("upload failed.");
        });
    },
    showDeleteConfirm() {
      this.$confirm({
        title: this.$t("Are you sure you want to delete the current page?"),
        content: this.$t("Current page") + " - " + this.currentPage,
        okText: this.$t("Yes"),
        okType: "danger",
        cancelText: this.$t("No"),
        onOk: () => {
          this.DeletePageloading = true;
          deletePage(this.element.ID, this.currentPage)
            .done(() => {
              let index = this.newPages.indexOf(this.currentPage);
              this.newPages.splice(index, 1);
              for (let i = index; i < this.newPages.length; i++) {
                this.newPages[i]--;
              }
              this.currentPage--;
              this.countPages--;

              this.getpdf();
            })
            .fail((e) => console.err(e))
            .always(() => {
              this.DeletePageloading = false;
            });
        },
        onCancel() { },
      });
    },
    next() {
      this.currentPage++;
    },
    prev() {
      this.currentPage--;
    },
    async back(data) {
      this.changeSpinning();
      await editClose(this.element.mainid);
      this.$emit("back", {
        unshift_elem: data.unshift_elem,
        remove_elem: data.remove_elem,
        invoice: data.doc_record,
      });
      this.changeSpinning();
      document.getElementById("maindivmenu").scrollIntoView();
    },
    preview() {
      this.$emit("preview", {
        file: this.element,
        page: this.currentPage,
      });
    },
    changeSpinning() {
      this.spinning = !this.spinning;
    },
    submit() {
      this.$refs.form.submit(this.comments);
    },
    Uint8ArrayFromBase64(base64) {
      return Uint8Array.from(window.atob(base64), (v) => v.charCodeAt(0));
    },
    getpdf() {
      let pdfAsArray = this.Uint8ArrayFromBase64(this.element.base64file);

      this.prew_doc_spinner = true;
      // var url = this.element.DOWNLOAD_URL || this.element.url;
      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
      // var loadingTask = pdfjsLib.getDocument(url);
      var loadingTask = pdfjsLib.getDocument(pdfAsArray);
      loadingTask.promise.then(
        (pdf) => {
          try {
            this.countPages = pdf.numPages;
            if (1 <= this.currentPage && this.countPages >= this.currentPage)
              pdf.getPage(this.currentPage).then((page) => {
                var canvas = document.getElementById("pdf-canvas-step");

                let realW = $("#pdf-canvas-step").width();
                var viewport = page.getViewport({
                  scale: realW / page.getViewport({ scale: 1.0 }).width,
                });
                var context = canvas.getContext("2d");
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                var renderContext = {
                  canvasContext: context,
                  viewport: viewport,
                };
                page
                  .render(renderContext)
                  .promise.then(() => {
                    canvas.style.display = "unset";
                    if (this.current == 0) {
                      page.getTextContent().then((textContent) => {
                        if (textContent.items.length) {
                          let titles = textContent.items.map((x) => x.str);
                          this.bounds = [
                            {
                              label: "whole",
                              text: titles.join(" "),
                              titles,
                            },
                          ];
                          this.prew_doc_spinner = false;
                        } else {
                          // findOCR(
                          //   canvas.toDataURL("img/jpeg", 1),
                          //   this.user_setup.api_ocr_token,
                          //   url
                          // )
                          //   .done((res, state) => {
                          //     if (state == "success") {
                          //       this.bounds = res.bounds;
                          //     }
                          //   })
                          //   .catch(()=>{})
                          //   .always(() => {
                          //     this.prew_doc_spinner = false;
                          //   });
                        }
                      });
                      this.prew_doc_spinner = false;
                    } else {
                      this.prew_doc_spinner = false;
                    }

                    BX24.fitWindow();
                    return page.getTextContent();
                  })
                  .then(function (textContent) {
                    var pdf_canvas = $("#pdf-canvas-step");

                    var canvas_height = pdf_canvas.get(0).height;
                    var canvas_width = pdf_canvas.get(0).width;

                    $("#text-layer-step").css({
                      // left: canvas_offset.left + "px",
                      // top: canvas_offset.top + "px",
                      left: "2px",
                      top: "2px",
                      height: canvas_height + "px",
                      width: canvas_width + "px",
                    });
                    pdfjsLib.renderTextLayer({
                      textContent: textContent,

                      container: $("#text-layer-step").get(0),
                      viewport,
                      textDivs: [],
                    });
                  });
              });
          } catch {
            this.prew_doc = true;
            this.prew_doc_spinner = false;
          }
        },
        (reason) => {
          // PDF loading error
          this.prew_doc = true;
          this.prew_doc_spinner = false;
          console.error(reason);
        }
      );
    },
    handleHistoryFile() {
      this.changeSpinning();
      let doc_id =
        this.element.mainid != undefined
          ? this.element.mainid
          : this.element.mainid;
      getHistory(doc_id).done((x) => {
        this.changeSpinning();
        this.element.HISTORY = x != "" ? JSON.parse(x) : {};
        this.prew_history = !this.prew_history;
      });
    },
    handleReturnToNew() {
      this.changeSpinning();
      returnToNew(this.element.mainid)
        .done(() => {
          this.back({ remove_elem: this.element.ID, unshift_elem: true });
          this.$message.success(this.$t("Back to description"));
        })
        .fail((e) => console.error(e))
        .always(() => this.changeSpinning());
    },
    handleReturnToDesc() {
      this.changeSpinning();
      returnToDescription(this.element.mainid)
        .done(() => {
          this.back({ remove_elem: this.element.ID, unshift_elem: true });
          this.$message.success(this.$t("Back to description"));
        })
        .fail((e) => console.error(e))
        .always(() => this.changeSpinning());
    },
    getUser(id) {
      let user = this.element.userList.find((x) => x.ID == id);
      return user ? user.NAME + " " + user.LAST_NAME : "";
    },
    resize() {
      BX24.resizeWindow(
        parseInt($("body #root_block").css("width")),
        parseInt($("body #root_block").css("height"))
      );
    },
    getMimeFromUint8Array(uint8Array) {
      const header = Array.from(uint8Array.slice(0, 4))
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");
      switch (header) {
        case "25504446":
          return "application/pdf"; // %PDF
        case "89504e47":
          return "image/png"; // PNG
        case "ffd8ffe0": // fallthrough
        case "ffd8ffe1":
        case "ffd8ffe2":
          return "image/jpeg"; // JPG
        default:
          return "unknown";
      }
    },
  },
  mounted() {

    let pdfAsArray = this.Uint8ArrayFromBase64(this.element.base64file);
    const mimeType = this.getMimeFromUint8Array(pdfAsArray);
    // console.log("steps 📂 Detected MIME type:", mimeType);

    // if (
    //   this.element.NAME.indexOf(".jpg") != -1 ||
    //   this.element.NAME.indexOf(".png") != -1
    // ) {
      if (mimeType === "image/png" || mimeType === "image/jpeg") {
      this.docPdf = false;
      this.prew_doc_spinner = false;
    } else {
      this.getpdf();

    }
    if (
      this.profile.ID == this.element.currentlyeditor ||
      !this.element?.currentlyeditor
    ) {
      this.currentEdit = true;
    }
    this.deadline = Date.now() + 1000 * 600;
  },
};
</script>

<style scoped>
.appBlock {
  display: flex;
  text-align: left;
  flex-direction: column;
  justify-content: flex-start;
  margin: auto;
}

.appBlock .title {
  font-size: 24px;
}

.steps {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}

.steps>div:first-child {
  width: 100%;
  padding: 15px 0px;
}

.steps>div:last-child {
  align-self: center;
}

.mainBlock--form>div:first-child {
  display: flex;
}

.mainBlock--btn {
  margin-top: 20px;
}
</style>
